import produce from 'immer'
import * as types from 'Redux/Types/VendorTypes'

const initialState = {
  fetchingVendors: false,
  next: null,
  previous: null,
  vendorAliases: [],
  vendors: [],
}

const fetchVendorAliases = (draft) => {
  draft.fetchingVendorAliases = true
}

const fetchVendorAliasesFailed = (draft) => {
  draft.fetchingVendorAliases = false
}

const fetchVendorAliasesSucceeded = (draft, { data }) => {
  draft.fetchingVendorAliases = false
  draft.vendorAliases = data
}

const fetchVendors = (draft) => {
  draft.fetchingVendors = true
}

const fetchVendorsFailed = (draft) => {
  draft.fetchingVendors = false
}

const fetchVendorsSucceeded = (draft, { data, next, previous }) => {
  draft.fetchingVendors = false
  draft.next = next
  draft.previous = previous
  draft.vendors = data
}

const vendorsReducer = (state = initialState, action) => {
  return produce(state, (draft) => {
    const { type, payload } = action

    switch (type) {
      case types.FETCH_VENDOR_ALIASES:
        return fetchVendorAliases(draft)

      case types.FETCH_VENDOR_ALIASES_FAILED:
        return fetchVendorAliasesFailed(draft)

      case types.FETCH_VENDOR_ALIASES_SUCCEEDED:
        return fetchVendorAliasesSucceeded(draft, payload)

      case types.FETCH_VENDORS:
        return fetchVendors(draft)

      case types.FETCH_VENDORS_FAILED:
        return fetchVendorsFailed(draft)

      case types.FETCH_VENDORS_SUCCEEDED:
        return fetchVendorsSucceeded(draft, payload)

      // no default
    }
  })
}

export default vendorsReducer
